function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M31,4.9h-3.8V3.4c0-0.6-0.4-1-1-1h-2.5c-0.8-1.2-2.1-2-3.6-2c-1.5,0-2.9,0.8-3.6,2h-2.5c-0.6,0-1,0.4-1,1v1.5H9 C7,4.9,5.3,6.6,5.3,8.7v27.2c0,2.1,1.7,3.8,3.8,3.8H31c2.1,0,3.8-1.7,3.8-3.8V8.7C34.7,6.6,33,4.9,31,4.9z M14.9,4.4H17 c0.4,0,0.8-0.2,0.9-0.6c0.4-0.8,1.2-1.4,2.1-1.4c0.9,0,1.7,0.5,2.1,1.4c0.2,0.4,0.5,0.6,0.9,0.6h2.1v2.5H14.9V4.4z M32.7,35.9 c0,1-0.8,1.8-1.8,1.8H9c-1,0-1.8-0.8-1.8-1.8V8.7c0-1,0.8-1.8,1.8-1.8h3.9v0.9c0,0.6,0.4,1,1,1h12.3c0.6,0,1-0.4,1-1V6.9H31 c1,0,1.8,0.8,1.8,1.8V35.9z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.1,21.3h7.4c0.6,0,1-0.4,1-1v-7.4c0-0.6-0.4-1-1-1h-7.4c-0.6,0-1,0.4-1,1v7.4C10.1,20.8,10.6,21.3,11.1,21.3z  M12.1,13.9h5.4v5.4h-5.4V13.9z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.8,16h-5.5c-0.6,0-1,0.4-1,1s0.4,1,1,1h5.5c0.6,0,1-0.4,1-1S29.4,16,28.8,16z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.8,20.2h-5.5c-0.6,0-1,0.4-1,1c0,0.6,0.4,1,1,1h5.5c0.6,0,1-0.4,1-1C29.8,20.6,29.4,20.2,28.8,20.2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.8,24.3H11.1c-0.6,0-1,0.4-1,1s0.4,1,1,1h17.7c0.6,0,1-0.4,1-1S29.4,24.3,28.8,24.3z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.8,28.4H11.1c-0.6,0-1,0.4-1,1s0.4,1,1,1h17.7c0.6,0,1-0.4,1-1S29.4,28.4,28.8,28.4z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.8,32.5H11.1c-0.6,0-1,0.4-1,1s0.4,1,1,1h17.7c0.6,0,1-0.4,1-1S29.4,32.5,28.8,32.5z"
}));

function SvgClipboard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "clipboard_svg__clipboard_svg__Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 40 40",
    style: {
      enableBackground: "new 0 0 40 40"
    },
    xmlSpace: "preserve"
  }, props), _ref);
}

export default SvgClipboard;